// The page an issue opens on, as a URL a browser can hold: every list
// renders it as a real link (href + target="_blank") so a right-click
// "open in new tab", a middle-click and a plain click all work, and the
// list you were scanning stays where it was.
export const issueHref = (issue) =>
  issue?.shareToken ? `/issue/${issue.shareToken}/resolve` : `/issue-viewer/${issue?._id || issue}`;

export const openIssueInNewTab = (issue) => {
  const w = window.open(issueHref(issue), "_blank", "noopener");
  if (w) w.opener = null;
};
